import useLoginCheck from 'hooks/common/useLoginCheck';
import { deletePlace, getStore } from 'lib/api/place';
import { initialize, setOriginalStore } from 'modules/storeSlice';
import { useEffect } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const usePlaceViewer = id => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { error, loading } = useSelector(({ store }) => store);

  const getStoreQuery = useQuery(['store', id], () => getStore(id));
  useLoginCheck(getStoreQuery.error?.response, getStoreQuery.refetch);
  const store = getStoreQuery.data?.data;

  const deleteStoreMutation = useMutation(deletePlace, {
    onSuccess: () => {
      navigate('/admin/places');
    },
  });
  useLoginCheck(deleteStoreMutation.error?.response, () => {
    deleteStoreMutation.mutate(id);
  });

  useEffect(() => {
    dispatch(initialize('error'));
  }, [dispatch]);

  const onEdit = () => {
    dispatch(
      setOriginalStore({
        code: store?.code,
        tel: store?.tel,
        space: store?.space,
      }),
    );
    navigate(`editor`);
  };

  const onDelete = () => {
    deleteStoreMutation.mutate(id);
  };

  return {
    error,
    loading,
    getStoreQuery,
    store,
    deleteStoreMutation,
    onDelete,
    onEdit,
  };
};

export default usePlaceViewer;
